<template>
	<v-layout style="page-break-inside: avoid" class="financial-table-header-light-color">
		<v-flex xs1 d-flex>
			<v-card color='grey lighten-1'>
				<v-card-text>
					<strong>
						{{1 + index}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs2 d-flex>
			<v-card color='grey lighten-1'>
				<v-card-text>
					<strong style="overflow-wrap: anywhere">
						{{invoice.documentName}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs2 d-flex>
			<v-card color='grey lighten-1'>
				<v-card-text>
					<strong style="overflow-wrap: anywhere">
						{{invoice.documentNumber}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs1 d-flex>
			<v-card color='grey lighten-1'>
				<v-card-text style="padding-left: 0px; padding-right: 5px; text-align: right">
					<strong>
						{{formatMoney(invoice.totalValue)}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs2 d-flex>
			<v-card color='grey lighten-1'>
				<v-card-text style="text-align: center">
					<strong>
						{{invoice.documentDate}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs2 d-flex>
			<v-card color='grey lighten-1'>
				<v-card-text style="text-align: center">
					<strong>
						{{invoice.paymentDates[0]}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs2 d-flex>
			<v-card color='grey lighten-1'>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>
	import {Numbers} from "../../../utils/Numbers";

	export default {
		name: "FinalReportInvoicesInvoiceGeneralDataRow",

		props: {
			index: {},
			invoice: {}
		},

		mixins: [Numbers]
	};
</script>

<style scoped>

</style>